<template>
  <v-app>
    <Navigation />
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="error.is"
      color="error"
      :timeout="0"
      :top="true"
    >
      Error {{ error.code }} {{ error.message }}
      <v-btn
        dark
        text
        @click="error.is = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import auth from "@/auth/authService";
import Navigation from '@/components/Navigation.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: { Navigation },
  computed: {
    ...mapGetters(['error'])
  },
  created() {
    auth.renewTokens().then(() => {
    });
  },
  methods: {
  }
}
</script>

<style>
  .v-tabs__content {
    padding-bottom: 2px;
  }
  table tbody tr {
    border: 0px solid black !important;
  }
  table tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .02);
  }
  .v-icon {
    display: inline-flex !important;
  }
  .underline {
    text-decoration: underline;
    color: #0000EE;
    cursor: pointer;
  }
  .tt20 td:first-child {
    width: 20%;
  }
</style>
